import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  assessmentContainer: {
    padding: 0,
  },
  logo: {
    [theme.breakpoints.down("sm")]: {
      width: "inherit",
    },
  },
  title: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      fontSize: 20,
    },
  },
  completedTitle: {
    color: "#353535",
  },
  completedSubtitle: {
    color: "#353535",
    fontSize: 20,
    [theme.breakpoints.down("sm")]: {
      fontSize: 18,
    },
  },
  completedBody: {
    color: theme.palette.text.secondary,
  },
  form: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "100%",
    },
  },
  paper: {
    position: "relative",
    padding: theme.spacing(2),
    paddingTop: theme.spacing(6),
    textAlign: "center",
    color: theme.palette.text.secondary,
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(3),
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(5),
    },
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  btnComplete: {
    backgroundColor: "blue",
    color: "white",
    "&:hover": {
      backgroundColor: "blue !important",
    },
  },
  ribbonImage: {
    position: "absolute",
    width: "20%",
    right: 0,
    left: 0,
    marginRight: "auto",
    marginLeft: "auto",
    height: "150px !important",
    maxWidth: "250px !important",
    maxHeight: "150px !important",
    minHeight: "30px !important",
    [theme.breakpoints.only("xs")]: {
      top: theme.spacing(-9),
    },
    [theme.breakpoints.only("sm")]: {
      top: theme.spacing(-9),
    },
    [theme.breakpoints.only("md")]: {
      top: theme.spacing(-8),
    },
    [theme.breakpoints.up("lg")]: {
      top: theme.spacing(-8),
    },
  },
}));

export default useStyles;
